import axios from "axios"
import { UrlApi } from "../Keys"
import { toast } from "react-toastify"

let loadingToast = null

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  })
}
const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}
const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const dataInicial = {
  legajo: [],
  loadingLegajo: false,
  estadoActualizacion: "",
  respuestaActualizacion: "",
  usuarioAutor: [],
  loadingUsuarioAutor: false,
  usuarioLider: [],
  loadingUsuarioLider: false,
}

const LOADING = "LOADING"
const LEGAJO = "LEGAJO"
const LEGAJO_ERROR = "LEGAJO_ERROR"

const ACTUALIZACION_LEGAJO_LOADING = "ACTUALIZACION_LEGAJO_LOADING"
const ACTUALIZACION_LEGAJO_EXITO = "ACTUALIZACION_LEGAJO_EXITO"
const ACTUALIZACION_LEGAJO_ERROR = "ACTUALIZACION_LEGAJO_ERROR"

const USUARIO_LOADING = 'USUARIO_LOADING'
const USUARIO_EXITO = 'USUARIO_EXITO'
const USUARIO_ERROR = 'USUARIO_ERROR'

const LOADING_USUARIO_LIDER = 'LOADING_USUARIO_LIDER'
const USUARIO_LIDER = 'USUARIO_LIDER'
const USUARIO_LIDER_ERROR = 'USUARIO_LIDER_ERROR'

//Reducers
export default function legajoReducer(state = dataInicial, action) {
  switch (action.type) {
    case LEGAJO:
      return { ...state, legajo: action.payload, loadingLegajo: action.loadingLegajo }
    case LOADING:
      return { ...state, loadingLegajo: action.loadingLegajo }
    case ACTUALIZACION_LEGAJO_LOADING:
      return { ...state, estadoActualizacion: action.resultado }
    case ACTUALIZACION_LEGAJO_EXITO:
      return { ...state, respuestaActualizacion: action.payload, estadoActualizacion: action.resultado }
    case ACTUALIZACION_LEGAJO_ERROR:
      return { ...state, estadoActualizacion: action.resultado }
    case USUARIO_LOADING:
      return { ...state, loadingUsuarioAutor: action.loadingUsuarioAutor }
    case USUARIO_EXITO:
      return { ...state, usuarioAutor: action.payload, loadingUsuarioAutor: action.loadingUsuarioAutor }
    case USUARIO_ERROR:
      return { ...state, loadingUsuarioAutor: action.loadingUsuarioAutor }
    case LOADING_USUARIO_LIDER:
      return { ...state, loadingUsuarioLider: action.loadingUsuarioLider }
    case USUARIO_LIDER:
      return { ...state, usuarioLider: action.payload, loadingUsuarioLider: action.loadingUsuarioLider }
    case USUARIO_LIDER_ERROR:
      return { ...state, loadingUsuarioLider: action.loadingUsuarioLider }
    default:
      return { ...state }
  }
}

export const miLegajo = (token, empleadoid) => async (dispatch) => {
  dispatch({
    type: LOADING,
    loadingLegajo: true,
  })

  try {
    var entidad = "new_empleados"
    var fetch =
      "<entity name='new_empleado'>" +
      "<attribute name='new_name'/>" +
      "<attribute name='new_usuariocanvas'/>" +
      "<attribute name='new_numerolegajo'/>" +
      "<attribute name='new_posicin'/>" +
      "<attribute name='new_correoelectronico'/>" +
      "<attribute name='new_empresa'/>" +
      "<attribute name='new_empleadoid'/>" +
      "<attribute name='new_tipodocumento'/>" +
      "<attribute name='new_nrodocumento' />" +
      "<attribute name='new_tipodeincorporacion' />" +
      "<attribute name='new_telefonoparticular' />" +
      "<attribute name='new_telefonomovil' />" +
      "<attribute name='new_provincia'/>" +
      "<attribute name='new_piso'/>" +
      "<attribute name='new_paisnacimiento'/>" +
      "<attribute name='new_provincianacimiento' />" +
      "<attribute name='new_pais'/>" +
      "<attribute name='new_nro'/>" +
      "<attribute name='new_nombredepila'/>" +
      "<attribute name='new_localidad'/>" +
      "<attribute name='new_genero'/>" +
      "<attribute name='new_generootro'/>" +
      "<attribute name='new_fechanacimiento'/>" +
      "<attribute name='new_estadocivil'/>" +
      "<attribute name='new_edad'/>" +
      "<attribute name='new_depto'/>" +
      "<attribute name='new_cuitcuil'/>" +
      "<attribute name='new_correoelectronicopersonal'/>" +
      "<attribute name='new_usuarioportalrh' />" +
      "<attribute name='new_codigopostal'/>" +
      "<attribute name='new_calle'/>" +
      "<attribute name='new_barrio'/>" +
      "<attribute name='new_apellidos'/>" +
      "<attribute name='new_extenciontelefonica' />" +
      "<attribute name='new_subdisciplina'/>" +
      "<attribute name='new_informacionadicional'/>" +
      "<attribute name='new_nivel'/>" +
      "<attribute name='new_cantidadtotaldetesis'/>" +
      "<attribute name='new_canttesisdoctoralesdirigactualmente'/>" +
      "<attribute name='new_canttesismaestriasdirigyconcult'/>" +
      "<attribute name='new_cantmaestriasquedirigeactualmente'/>" +
      "<attribute name='new_canttesinasytrabfinales'/>" +
      "<attribute name='new_canttesinasytrabajosquedirigeactualmente'/>" +
      "<attribute name='new_experienciaeneducacinadistancia'/>" +
      "<attribute name='new_conicet'/>" +
      "<attribute name='new_programade'/>" +
      "<order attribute='new_numerolegajo' descending='false'/>" +
      "<filter type='and'>" +
      "<condition attribute='statecode' operator='eq' value='0'/>" +
      "<condition attribute='new_empleadoid' operator='eq' uitype='new_empleado' value='" +
      empleadoid +
      "'/>" +
      "</filter>" +
      "<link-entity name='new_posicion' from='new_posicionid' to='new_posicin' visible='false' link-type='outer' alias='a_a1e362a20ce2ea11a813002248360dfb'>" +
      "<attribute name='new_unidadorganizativa'/>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: LEGAJO,
      payload: response.data,
      loadingLegajo: false,
    })
  } catch (error) {
    dispatch({
      type: LEGAJO_ERROR,
      loadingLegajo: false,
    })
  }
}

export const actualizacionLegajo = (token, empleadoId, datos) => async (dispatch) => {
  dispatch({
    type: ACTUALIZACION_LEGAJO_LOADING,
    resultado: "LOADING",
  });

  await toast.promise(
    async () => {
      try {
        if (Object.keys(datos).length > 0 && token) {
          const response = await axios.put(
            `${UrlApi}api/hrfactors/empleado`,
            {
              new_empleadoid: empleadoId,
              new_estadocivil: datos.estadoCivil?.value ? Number(datos.estadoCivil.value) : 0,
              new_telefonomovil: datos.telefonoMovil?.toString(),
              new_telefonoparticular: datos.telefonoParticular?.toString(),
              new_extenciontelefonica: datos.extencionTefefonica?.toString(),
              new_paisnacimiento: datos.paisNacimiento?.value || "",
              new_calle: datos.calle || "",
              new_nro: datos.nroCalle?.toString(),
              new_piso: datos.piso?.toString(),
              new_depto: datos.depto?.toString(),
              new_localidad: datos.localidad?.value || "",
              new_codigopostal: datos.codigoPostal?.toString(),
              new_provincia: datos.provincia?.value || "",
              new_provincianacimiento: datos.provinciaNacimiento?.value || "",
              new_pais: datos.pais?.value || "",
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          dispatch({
            type: ACTUALIZACION_LEGAJO_EXITO,
            resultado: "EXITO",
            payload: response.data,
          });
          return response.data;
        }
      } catch (error) {
        console.log(error);
        dispatch({
          type: ACTUALIZACION_LEGAJO_ERROR,
          resultado: "ERROR",
        });
        throw error;
      }
    },
    {
      pending: "Procesando...",
      success: "Legajo actualizado con éxito",
      error: {
        render({ data }) {
          return "Ocurrio un error";
        },
      },
    },
    {
      theme: "dark",
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
};

export const usuario = (token, correo) => async (dispatch) => {
  dispatch({
    type: USUARIO_LOADING,
    loadingUsuarioAutor: true,
  })
  try {
    var entidad = "systemusers"
    var fetch = `<entity name="systemuser">
    <attribute name="systemuserid"/>
    <attribute name="internalemailaddress"/>
    <order attribute="fullname" descending="false"/>
    <filter type="and">
      <condition attribute="internalemailaddress" operator="eq" value="${correo}"/>
    </filter>
    </entity>`

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: USUARIO_EXITO,
      payload: response.data,
      loadingUsuarioAutor: false,
    })
  } catch (error) {
    dispatch({
      type: USUARIO_ERROR,
      loadingUsuarioAutor: false,
    })
  }
}

export const usuarioLider = (token, correo) => async (dispatch) => {
  dispatch({
    type: LOADING_USUARIO_LIDER,
    loadingUsuarioLider: true,
  })
  try {
    debugger
    var entidad = "new_empleados"
    var fetch = `<entity name="new_empleado">
    <attribute name="new_name"/>
    <attribute name="new_cuitcuil"/>
    <attribute name="new_correoelectronico"/>
    <attribute name="new_numerolegajo"/>
    <attribute name="new_empleadoid"/>
    <order attribute="new_numerolegajo" descending="false"/>
    <link-entity name="new_empleado" from="new_empleadoid" to="new_reportaaid" link-type="inner" alias="ab">
    <filter type="and">
    <condition attribute="new_correoelectronico" operator="eq" value="${correo}"/>
    </filter>
    </link-entity>
    </entity>`

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: USUARIO_LIDER,
      payload: response.data,
      loadingUsuarioLider: false,
    })
  } catch (error) {
    dispatch({
      type: USUARIO_LIDER_ERROR,
      loadingUsuarioLider: false,
    })
  }
}